import { render, staticRenderFns } from "./Square.vue?vue&type=template&id=ea5e7d62"
import script from "./Square.vue?vue&type=script&lang=js"
export * from "./Square.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports